import {
   useCreateAssistants,
   useGetActiveLeadSourceDetails,
} from '@forwardflow/hooks/customHooks/campaign'
import { useCampaignPhoneNumberCountStore } from '@forwardflow/store/campaignPhoneNumberCountStore'
import Icon from '@forwardflow/ui/Icons'
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom'

export const NavigationBar = () => {
   const location = useLocation()
   const [searchParams] = useSearchParams()
   const campaignName = searchParams.get('campaignName')
   const { title } = useParams()
   const { data: LeadSourceDetails, mutate } = useGetActiveLeadSourceDetails(
      title as string
   )
   const { count } = useCampaignPhoneNumberCountStore()
   // const onAdvanceSettingsChange = useCallback(async () => {
   //    setIsLoading(true)
   //    try {
   //       await CampaignService.updateCampaignConfigSettings(id as string, {
   //          isAdvanceConfiguration: !campaignConfig?.isAdvanceConfiguration,
   //       })
   //       mutate()
   //    } catch (error) {
   //       console.error('Failed to update assistants:', error)
   //    } finally {
   //       setIsLoading(false)
   //    }
   // }, [campaignConfig, id, mutate])

   useCreateAssistants({
      campaignTitle: title as string,
      aiAssistants: LeadSourceDetails?.data?.aiAssistants,
      onAssistantsCreated: () => {
         mutate()
      },
   })

   return (
      <div className="flex flex-col flex-1  max-w-[460px]">
         <div className="flex items-center justify-between px-10 py-5 font-medium text-white/70">
            Campaign Settings
         </div>

         <Link
            to={`/campaign/${title}/phone-number?campaignName=${campaignName}`}
            className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
               location.pathname?.includes(`/phone-number`) ? 'bg-primary' : ''
            }`}
         >
            <div className="flex items-center gap-x-2">
               <Icon name="Telephone" className="scale-[0.7] fill-white" />
               <span className="text-[14px] font-medium">Phone numbers</span>
            </div>
            <div className="flexc gap-x-3">
               <span className="text-white/50">{count ? count : ''} </span>
               <Icon
                  name="arrow-down"
                  className="scale-90 -rotate-90 fill-white"
               />
            </div>
         </Link>
         <Link
            to={`/campaign/${title}/assistants?campaignName=${campaignName}`}
            className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
               location.pathname?.includes(`/assistants`) ? 'bg-primary' : ''
            }`}
         >
            <div className="flex items-center gap-x-2">
               <Icon name="Persona" className="mx-1 fill-white" />
               <span className="text-[14px] font-medium">Assistants</span>
            </div>
            <div className="flexc gap-x-3">
               <span className="text-white/50">
                  {LeadSourceDetails?.data?.aiAssistants?.length}
               </span>
               <Icon
                  name="arrow-down"
                  className="scale-90 -rotate-90 fill-white"
               />
            </div>
         </Link>

         <div className=" bg-primary/20">
            {/* <div className="flex items-center justify-between px-10 py-4 min-h-[76px] cursor-pointer border-b border-black/20">
               <div className="flex items-center gap-x-2">
                  <Icon name="Settings" className="mx-1 fill-white" />
                  <span className="text-[14px] font-medium">
                     Advanced Configuration
                  </span>
               </div>
               <div className="flexc gap-x-3">
                  <Switch
                     className="bg-[#D9D9D9]/10 ff-switch"
                     checked={campaignConfig?.isAdvanceConfiguration}
                     onChange={onAdvanceSettingsChange}
                     loading={isLoading} // Assuming the Switch component supports a loading prop
                  />
               </div>
            </div> */}

            <>
               {/* {LeadSourceDetails?.data?.campaignType !== 'advanced' && (
                  <>
                     <Link
                        to={`/campaign/${title}/waiting-time?campaignName=${campaignName}`}
                        className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                           location.pathname?.includes(`/waiting-time`)
                              ? 'bg-primary'
                              : ''
                        }`}
                     >
                        <div className="flex items-center gap-x-2">
                           <Icon name="Clock" className="mx-1 fill-white" />
                           <span className="text-[14px] font-medium">
                              Waiting Time
                           </span>
                        </div>
                     </Link>
                  </>
               )} */}

               {/* <Link
                  to={`/campaign/${title}/working-hours?campaignName=${campaignName}`}
                  className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                     location.pathname?.includes(`/working-hours`)
                        ? 'bg-primary/80'
                        : ''
                  }`}
               >
                  <div className="flex items-center gap-x-2">
                     <Icon name="Calendar" className="mx-1 fill-white" />
                     <span className="text-[14px] font-medium">
                        Working hours
                     </span>
                  </div>
                  <div className="p-2 px-4 rounded bg-black/10 flexc">
                     {dayjs(
                        campaignConfig?.customBusinessHours?.[0]?.startTime,
                        'HH:mm'
                     ).format('hh:mm a')}
                     &nbsp; - &nbsp;
                     {dayjs(
                        campaignConfig?.customBusinessHours?.[0]?.endTime,
                        'HH:mm'
                     ).format('hh:mm a')}
                  </div>
               </Link> */}
               {/* <Link
                  to={`/campaign/${title}/appointment-timeframes?campaignName=${campaignName}`}
                  className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                     location.pathname?.includes(`/appointment-timeframes`)
                        ? 'bg-primary/80'
                        : ''
                  }`}
               >
                  <div className="flex items-center gap-x-2">
                     <Icon name="Calendar" className="mx-1 fill-white" />
                     <span className="text-[14px] font-medium">
                        Appointment timeframe
                     </span>
                  </div>
               </Link> */}
               {/* <Link
                  to={`/campaign/${title}/qualifying-questions?campaignName=${campaignName}`}
                  className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                     location.pathname?.includes(`/qualifying-questions`)
                        ? 'bg-primary/80'
                        : ''
                  }`}
               >
                  <div className="flex items-center gap-x-2">
                     <Icon name="Questions" className="mx-1 fill-white" />
                     <span className="text-[14px] font-medium">
                        Qualifying Questions
                     </span>
                  </div>
               </Link> */}
               {/* <Link
                     to={`/campaign/${id}/${title}/stage-mapping`}
                     className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                        location.pathname ===
                        `/campaign/${id}/${title}/stage-mapping`
                           ? 'bg-primary/50'
                           : ''
                     }`}
                  >
                     <div className="flex items-center gap-x-2">
                        <Icon
                           name="map-stage"
                           className="scale-[.7] fill-primary"
                        />
                        <span className="text-[14px] font-medium">
                           Modify Stage Mapping
                        </span>
                     </div>
                  </Link> */}
            </>
         </div>

         {/* <div className="px-10 py-4">Campaign Details</div>
         <Link
            to={`/campaign/${title}/campaign-usp?campaignName=${campaignName}`}
            className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
               location.pathname?.includes(`/campaign-usp`)
                  ? 'bg-primary'
                  : 'bg-[#D9D9D9]/5'
            }
                  `}
         >
            <div className="flex items-center gap-x-2">
               <Icon name="CampaignGoals" className="mx-1 fill-white" />
               <span className="text-[14px] font-medium">Campaign USPs</span>
            </div>
            <div className="flexc gap-x-3">
               <span className="text-white/50">
                  {LeadSourceDetails?.data?.usps?.length}
               </span>
               <Icon
                  name="arrow-down"
                  className="scale-90 -rotate-90 fill-white"
               />
            </div>
         </Link> */}
      </div>
   )
}
